import React, { useEffect, useState } from 'react';
import { Body, SubmitButton, FormCadastro, PageHeader, Select, GroupField, Field } from '@components';
import { getClientesConectores } from '@ducks/clientes';
import { postComandos, reset } from '@ducks/conectoresComandos';
import { Notification } from '@utils';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TreeConectores from './TreeConectores';
import {
  SelectFonte as LayoutSelectFonte,
  SQLConector as LayoutSQLConector,
  EnviarInformacaoBanco as LayoutEnviarInformacaoBanco,
  Types,
} from './TiposComando';

import App from '@app';
import { getTipos as getTiposComando } from '@sdk/Conectores/Tipos/Comando';
import styled from 'styled-components';

const FieldTp = styled(Field)`
  flex: 1;
`;

const FieldConectores = styled(Field)`
  flex: 2;
`;

export default function Detalhes() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const [tpLayout, setTpLayout] = useState('');

  const clientesConectores = useSelector(({ clientes }) => clientes.get('clientesConectores').toArray());
  const conectoresSelecionados = useSelector(({ conectoresComandos }) => conectoresComandos.get('conectoresSelecionados'));
  const successPostComandos = useSelector(({ conectoresComandos }) => conectoresComandos.get('successPostComandos'));

  const handleReset = () => {
    return dispatch(reset());
  };

  const handleSearch = () => {
    return dispatch(getClientesConectores());
  };

  useEffect(() => {
    handleReset();
    handleSearch();
  }, []);

  useEffect(() => {
    if (successPostComandos) {
      handleReset();
      history.goBack();
    }
  }, [successPostComandos]);

  useEffect(() => {
    const el = document.getElementById('tp');
    el.disabled = false;
    el.focus();
  }, []);

  function handleSubmit(data) {
    if (conectoresSelecionados.length === 0) {
      Notification.error('Selecione ao menos um conector');
      return;
    }

    const conectores = conectoresSelecionados.map((conector) => {
      const configuracao = conector.split('-');

      if (configuracao[1] === '0') {
        const cliente = clientesConectores.find((cliente) => cliente.key === conector);

        return cliente.children.map((configuracao) => {
          return parseInt(configuracao.key.split('-')[1]);
        });
      } else {
        return parseInt(configuracao[1]);
      }
    });

    // eslint-disable-next-line
    let comando = undefined;
    if (data.comando) {
      if (data.tp === 'SELECT_FONTE') {
        comando = {
          comando: data.comando,
          conexao: data.conexao.split('-')[0],
        };
        comando = JSON.stringify(comando);
      } else {
        const { comando: object } = data;
        comando = object;
      }
    }

    let body = [];

    conectores.forEach((conector) => {
      if (typeof conector === 'object') {
        for (let index = 0; index < conector.length; index++) {
          body.push({
            idConfiguracao: conector[index],
            tp: data.tp,
            comando,
            origem: 'WEB',
          });
        }
      } else {
        body.push({
          idConfiguracao: conector,
          tp: data.tp,
          comando,
          origem: 'WEB',
        });
      }
    });

    dispatch(postComandos(body));
  }

  function handleTpLayoutChange() {
    switch (tpLayout) {
      case Types.SELECT_FONTE:
        return <LayoutSelectFonte form={form} />;
      case Types.SQL_CONECTOR:
        return <LayoutSQLConector />;
      case Types.ENVIAR_INFORMACAO_BANCO:
        return <LayoutEnviarInformacaoBanco />;
      default:
    }
  }

  return (
    <App>
      <Body>
        <PageHeader title="Comando" onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <FieldTp label="Tipo" name="tp" rules={[{ required: true, message: 'Informe o tipo' }]}>
                <Select
                  form={form}
                  name="tp"
                  action={() => getTiposComando()}
                  placeholder="Selecione um tipo"
                  autoFocus
                  onChange={(value) => setTpLayout(value)}
                />
              </FieldTp>
              <FieldConectores label="Conectores">
                <TreeConectores treeData={clientesConectores} />
              </FieldConectores>
            </GroupField>
            {handleTpLayoutChange()}
            <SubmitButton type="success" htmlType="submit" block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
